<template>
	<div class="drawer">
		<el-drawer
		v-if="yuyueId"
		size="363px"
		title="预约审核"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<img src="../../../../assets/img/remark.png" class="avatar"/>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">审核结果：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="check" placeholder="请选择">
								<el-option v-for="item in [{value:1,label:'通过'},{value:0,label:'不通过'}]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">审核备注：</span>
						<span class="value" style="vertical-align: top;">
							<el-input style="width:200px;" type="textarea" :rows="5" v-model="reason" placeholder="请输入备注"></el-input>
						</span>
					</el-col>
				</el-row>
				<div>
					<el-button style="width:280px;margin:80px 0 0 40px;" type="primary" size="mini" @click="submit_check">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				check:1,
				reason:'',
			}
		},
		props:{
			yuyueId:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit_check(){
				if(this.check==1){
					let params = {
						id:this.yuyueId,
						remark:this.reason
					}
					this.$http.get('/api/Reservation/HandleSuccess', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}else{
					if(this.reason==''){
						this.$message({
							message: '请填写审核失败备注',
							type: 'error'
						});
						return ;
					}
					let params = {
						id:this.yuyueId,
						remark:this.reason
					}
					this.$http.get('/api/Reservation/HandleFail', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}
				this.check = 1;
				this.reason = '';
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.label{
				display: inline-block;width:100px;text-align: right;
			}
		}
		
	}
	
</style>
